export { GiftCardBalancePage as default } from './GiftCardBalancePage';
